import type { ReactNode } from 'react';
import React from 'react';
import { t } from 'Src/i18n';
import { classnames } from 'Utils/classnames/classnames.utils';
import { Button } from 'Components/frameworks/button/Button';
type Props = {
  children: ReactNode;
  className?: string;
  onSelect: () => void;
  isUpgradableOnline?: boolean;
};
export const AccommodationOptionCurrent = ({
  children,
  className,
  isUpgradableOnline = true,
  onSelect,
  ...rest
}: Props) => (
  <div
    {...rest}
    className={classnames(
      'relative isolate flex flex-col rounded-12 border-1 border-lightGrey bg-white',
      className,
    )}
    data-testid="AccommodationOptionCurrent"
  >
    <div className="flex-1 overflow-y-auto">{children}</div>
    <div className="flex items-center justify-center gap-10 border-t-1 border-lightGrey p-20">
      <Button className="w-auto" onClick={onSelect}>
        {isUpgradableOnline
          ? t('common.confirm')
          : t('booking.accommodation.upgradeRoom.contactATED')}
      </Button>
    </div>
  </div>
);
